import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-605804b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "payment__slider" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "payment-slide" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "payment-slide__icon-box" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon icon-list-view" })
  ]),
  /*#__PURE__*/_createElementVNode("h2", { class: "payment-slide__title" }, "A lot more case"),
  /*#__PURE__*/_createElementVNode("p", { class: "payment-slide__text" }, "Create up to 300 case")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "payment-slide" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "payment-slide__icon-box" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon icon-list-view" })
  ]),
  /*#__PURE__*/_createElementVNode("h2", { class: "payment-slide__title" }, "A lot more case"),
  /*#__PURE__*/_createElementVNode("p", { class: "payment-slide__text" }, "Create up to 300 case")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "payment-slide" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "payment-slide__icon-box" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon icon-list-view" })
  ]),
  /*#__PURE__*/_createElementVNode("h2", { class: "payment-slide__title" }, "A lot more case"),
  /*#__PURE__*/_createElementVNode("p", { class: "payment-slide__text" }, "Create up to 300 case")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "payment__title bold" }, " Professional ", -1))
const _hoisted_6 = { class: "payment__items" }
const _hoisted_7 = { class: "payment-item__title" }
const _hoisted_8 = { class: "payment-item__price bold" }
const _hoisted_9 = { class: "payment-item__price-month" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "payment__text" }, "Account didn't upgrade?", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "payment__text bold" }, "Refresh Subscription", -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Continue ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, {
    direction: "vertical",
    class: "payment height-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_swiper, {
          class: "payment-slider",
          modules: _ctx.modules,
          pagination: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_swiper_slide, { class: "payment-slider__slide" }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_swiper_slide, { class: "payment-slider__slide" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_swiper_slide, { class: "payment-slider__slide" }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modules"])
      ]),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableProducts, (product) => {
          return (_openBlock(), _createElementBlock("div", {
            key: product.value,
            class: "payment-item"
          }, [
            _createElementVNode("h2", _hoisted_7, _toDisplayString(product.name), 1),
            _createElementVNode("p", _hoisted_8, _toDisplayString(product.price) + "$", 1),
            _createElementVNode("p", _hoisted_9, _toDisplayString(product.description), 1)
          ]))
        }), 128))
      ]),
      _hoisted_10,
      _hoisted_11,
      _createVNode(_component_app_button, {
        type: "primary",
        "native-type": "submit",
        class: "payment__action-btn w-100 el-button-lg",
        round: ""
      }, {
        default: _withCtx(() => [
          _hoisted_12
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}